import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const SidebarToggleIcon = props => (
  <SvgIcon {...props}>
    <path d="M4,18H9V5H4ZM10,5V18H21V5Z" />
  </SvgIcon>
);

export default SidebarToggleIcon;
